/* MacShack Mac for Business page: hero entrance, "Can Mac…?" picker, reason tabs with their
   animated visuals, the team quote builder (live prices from the page, pre-written WhatsApp and
   email), lineup prices and scroll reveals. Works as plain content without JavaScript. */
(function () {
  'use strict';

  function init(root) {
    if (root.__mfb) return; root.__mfb = true;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var $ = function (s, r) { return (r || root).querySelector(s); };
    var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };

    /* Sticky offset below the store header */
    function setTop() {
      var h = document.querySelector('sticky-header header, .header-wrapper header, header.header') || document.querySelector('header:not(.hero)');
      var off = 24;
      if (h) {
        var wrap = h.closest('sticky-header, .section-header, .shopify-section-group-header-group') || h;
        var pos = getComputedStyle(wrap).position;
        if (pos === 'sticky' || pos === 'fixed') off = Math.round(h.getBoundingClientRect().height) + 20;
      }
      root.style.setProperty('--mfb-top', off + 'px');
    }
    setTop(); window.addEventListener('resize', setTop);

    /* Hero entrance */
    var hero = $('[data-hero]');
    if (hero) {
      if (!reduce && window.scrollY < 200) {
        hero.classList.add('load'); void hero.offsetWidth;
        requestAnimationFrame(function () { requestAnimationFrame(function () { hero.classList.add('go'); }); });
        setTimeout(function () { hero.classList.remove('load'); }, 2400);
      }
    }

    /* ---- Animated hero: lid opens, screen wakes, a workday plays on loop ---- */
    var hv = $('[data-hv]');
    if (hv) {
      var scr = $('.hv-scr', hv), cur = $('.hv-cursor', hv), clockEl = $('[data-hv-clock]', hv), ptime = $('[data-hv-ptime]', hv);
      var setClock = function (t) { if (clockEl) clockEl.textContent = 'Mon ' + t; if (ptime) ptime.textContent = t; };
      if (reduce) {
        hv.classList.add('open', 'on', 'st-sheet', 'st-call', 'st-note');
        setClock('15:45');
      } else {
        var timers = [], visible = true, running = false;
        var later = function (ms, fn) { timers.push(setTimeout(fn, ms)); };
        var aim = function (el) {
          if (!el || !cur) return;
          var a = scr.getBoundingClientRect(), b = el.getBoundingClientRect();
          cur.style.left = ((b.left + b.width * .55 - a.left) / a.width * 100) + '%';
          cur.style.top = ((b.top + b.height * .5 - a.top) / a.height * 100) + '%';
        };
        var click = function (app) {
          var icon = $('[data-hv-app="' + app + '"]', hv);
          cur.classList.remove('click'); void cur.offsetWidth; cur.classList.add('click');
          if (icon) { icon.classList.remove('bounce'); void icon.offsetWidth; icon.classList.add('bounce', 'run'); }
        };
        var loop = function () {
          if (!visible) { running = false; return; }
          running = true;
          setClock('09:00');
          later(200, function () { aim($('[data-hv-app="sheet"]', hv)); });
          later(1400, function () { click('sheet'); });
          later(1900, function () { hv.classList.add('st-sheet'); setClock('10:15'); });
          later(4300, function () { aim($('[data-hv-app="call"]', hv)); });
          later(5500, function () { click('call'); });
          later(6000, function () { hv.classList.add('st-call'); setClock('11:30'); });
          later(7600, function () { cur.style.left = '62%'; cur.style.top = '70%'; });
          later(8800, function () { hv.classList.add('st-note'); setClock('15:45'); });
          later(12000, function () { setClock('17:30'); });
          later(13800, function () { hv.classList.remove('st-sheet', 'st-call', 'st-note'); $$('.hv-dock i', hv).forEach(function (i) { i.classList.remove('run', 'bounce'); }); });
          later(15000, loop);
        };
        var started = false;
        var start = function () {
          if (started) return; started = true;
          setTimeout(function () { hv.classList.add('open'); }, 150);
          setTimeout(function () { hv.classList.add('on'); }, 1600);
          setTimeout(function () { if (!running) loop(); }, 2400);
        };
        if ('IntersectionObserver' in window) {
          /* The lid opens the first time the Mac is properly in view, so nobody misses it. */
          new IntersectionObserver(function (es) {
            var e = es[0];
            visible = e.isIntersecting;
            if (e.intersectionRatio >= .4) start();
            if (visible && started && !running && hv.classList.contains('on')) loop();
          }, { threshold: [0, .15, .4] }).observe(hv);
        } else start();
      }
    }

    /* ---- Can Mac…? ---- */
    var qa = $('[data-qa]');
    if (qa) {
      var ans = $('.ans', qa);
      $$('[data-does]', qa).forEach(function (el) {
        var txt = el.textContent.trim(); el.setAttribute('aria-label', txt); el.innerHTML = '';
        var n = 0;
        txt.split(' ').forEach(function (word, wi) {
          if (wi) el.appendChild(document.createTextNode(' '));
          var w = document.createElement('span'); w.className = 'w'; w.setAttribute('aria-hidden', 'true');
          word.split('').forEach(function (c) {
            var s = document.createElement('span'); s.className = 'ch'; s.textContent = c;
            s.style.setProperty('--i', n++); w.appendChild(s);
          });
          n++; el.appendChild(w);
        });
        var sr = document.createElement('span'); sr.className = 'sr'; sr.textContent = txt; el.appendChild(sr);
      });
      $$('.q', qa).forEach(function (b) {
        b.addEventListener('click', function () {
          var i = b.getAttribute('data-q');
          $$('.q', qa).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          $$('[data-a]', qa).forEach(function (p) { p.hidden = p.getAttribute('data-a') !== i; });
          if (!reduce) { ans.classList.remove('swap'); void ans.offsetWidth; ans.classList.add('swap'); }
          var list = b.parentElement;
          if (list.scrollWidth > list.clientWidth) {
            var left = b.offsetLeft - (list.clientWidth - b.offsetWidth) / 2;
            list.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' });
          }
        });
      });
    }

    /* ---- Reason tabs ---- */
    var seg = $('[data-seg]');
    if (seg) {
      var thumb = $('.thumb', seg), tabs = $$('[role=tab]', seg), flowTimer;
      var place = function (btn) { thumb.style.left = btn.offsetLeft + 'px'; thumb.style.width = btn.offsetWidth + 'px'; };
      var runFlow = function (pane) {
        clearInterval(flowTimer);
        var st = $$('.fstep', pane); st.forEach(function (s) { s.classList.remove('on', 'done'); });
        if (reduce) { st.forEach(function (s) { s.classList.add('on', 'done'); }); return; }
        var k = 0;
        flowTimer = setInterval(function () {
          if (k > 0) st[k - 1].classList.add('done');
          if (k < st.length) st[k].classList.add('on'); else clearInterval(flowTimer);
          k++;
        }, 650);
      };
      var select = function (i, focus) {
        tabs.forEach(function (t, j) {
          var on = i === j, p = document.getElementById(t.getAttribute('aria-controls'));
          t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1; p.hidden = !on;
          if (on) {
            if (!reduce) { p.classList.remove('swap'); void p.offsetWidth; p.classList.add('swap'); } else p.classList.add('play');
            if (focus) t.focus();
            if (p.getAttribute('data-visual') === 'flow') runFlow(p);
          }
        });
        place(tabs[i]);
      };
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(i); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); select((i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length, true); }
        });
      });
      place(tabs[0]);
      window.addEventListener('resize', function () { place($('[aria-selected="true"]', seg)); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { place($('[aria-selected="true"]', seg)); });
      /* first tab's visual plays when it scrolls into view */
      var first = document.getElementById(tabs[0].getAttribute('aria-controls'));
      if ('IntersectionObserver' in window) {
        var vo = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('play'); if (e.target.getAttribute('data-visual') === 'flow' && !e.target.hidden) runFlow(e.target); vo.unobserve(e.target); } });
        }, { threshold: .35 });
        vo.observe(first);
      } else first.classList.add('play');
    }

    /* ---- Prices ---- */
    var M = {};
    var data = $('[data-macs]');
    if (data) { try { M = JSON.parse(data.textContent); } catch (e) { M = {}; } }
    var R = function (v) { return 'R' + String(Math.round(v)).replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
    $$('[data-mac]').forEach(function (card) {
      var m = M[card.getAttribute('data-mac')]; if (!m) return;
      var nw = $('[data-p="nw"]', card), po = $('[data-p="po"]', card);
      if (nw) nw.textContent = m.nw ? R(m.nw) : 'Ask us';
      if (po) {
        po.textContent = m.po ? R(m.po) : '—';
        if (!m.po && po.previousElementSibling) po.previousElementSibling.textContent = 'Pre-owned';
      }
    });

    /* ---- Quote builder ---- */
    var qb = $('[data-qb]');
    if (qb) {
      var cond = 'new', extras = {}, shown = 0;
      var wa = root.getAttribute('data-wa'), email = root.getAttribute('data-email');
      var intro = qb.getAttribute('data-intro') || "Hi MacShack, I'd like a business quote for:";
      var rows = $$('.role', qb).map(function (row) {
        return { el: row, name: row.getAttribute('data-name'), nw: row.getAttribute('data-new'), po: row.getAttribute('data-used') || row.getAttribute('data-new'), c: +row.getAttribute('data-start') || 0 };
      });
      var pick = function (r) {
        var key = cond === 'mix' ? r.po : r.nw, m = M[key] || M[r.nw];
        if (!m) return null;
        var used = cond === 'mix' && !!m.po;
        return { m: m, used: used, price: used ? m.po : m.nw, newPrice: (M[r.nw] || m).nw };
      };
      var tween = function (el, to) {
        var from = shown; shown = to;
        if (reduce || from === to) { el.innerHTML = '<small>from</small>' + R(to); return; }
        var t0 = performance.now(), dur = 600;
        (function f(t) {
          var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3);
          el.innerHTML = '<small>from</small>' + R(from + (to - from) * e);
          if (p < 1) requestAnimationFrame(f);
        })(t0);
        el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
      };
      var esc = function (s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); };
      var render = function () {
        var total = 0, allNew = 0, people = 0, groups = {}, gorder = [], msg = [];
        rows.forEach(function (r) {
          var p = pick(r), row = r.el;
          if (!p) { row.hidden = true; return; }
          var img = $('img', row);
          if (p.m.img && img.getAttribute('src') !== p.m.img) img.src = p.m.img;
          $('.rec', row).innerHTML = '<span class="sg">Suggested: </span><b>' + esc(p.m.n) + '</b>' + (p.used ? ' · pre-owned' : ' · new');
          $('.px', row).textContent = p.price ? 'from ' + R(p.price) + ' each' : 'Price on request';
          $('output', row).textContent = r.c;
          $('[data-d="-1"]', row).disabled = r.c === 0;
          $('[data-d="1"]', row).disabled = r.c >= 99;
          row.classList.toggle('has', r.c > 0);
          if (r.c) {
            total += r.c * p.price; allNew += r.c * p.newPrice; people += r.c;
            var gk = p.m.n + (p.used ? ' (pre-owned)' : '');
            if (!groups[gk]) { groups[gk] = { c: 0, sum: 0 }; gorder.push(gk); }
            groups[gk].c += r.c; groups[gk].sum += r.c * p.price;
            msg.push('• ' + r.c + ' × ' + p.m.n + (p.used ? ' (pre-owned)' : ' (new)') + ' for ' + r.name.toLowerCase());
          }
        });
        var lines = gorder.map(function (k) { return '<li><span>' + groups[k].c + ' × ' + esc(k) + '</span><span>' + R(groups[k].sum) + '</span></li>'; });
        tween($('[data-total]', qb), total);
        $('[data-meta]', qb).textContent = people ? people + (people === 1 ? ' Mac' : ' Macs') + ' · VAT included' : 'Add your first person to start.';
        $('[data-lines]', qb).innerHTML = lines.length ? lines.join('') : '<li class="empty">No Macs added yet</li>';
        var save = $('[data-save]', qb), diff = allNew - total;
        save.hidden = !(diff > 0);
        $('span', save).textContent = 'From ' + R(diff) + ' less than all new';
        var ex = Object.keys(extras).filter(function (k) { return extras[k]; });
        var text = intro + '\n' + (msg.length ? msg.join('\n') : '• (team still to add)') +
          (ex.length ? '\nAlso interested in: ' + ex.join(', ') + '.' : '') + '\nCompany: \nVAT number: ';
        $('[data-bubble]', qb).textContent = text;
        $('[data-wa]', qb).href = 'https://wa.me/' + wa + '?text=' + encodeURIComponent(text);
        $('[data-mail]', qb).href = 'mailto:' + email + '?subject=' + encodeURIComponent('Business quote request') + '&body=' + encodeURIComponent(text);
      };
      qb.addEventListener('click', function (e) {
        var b = e.target.closest('[data-d]'); if (!b) return;
        var row = b.closest('.role'), r = rows.filter(function (x) { return x.el === row; })[0];
        r.c = Math.max(0, Math.min(99, r.c + +b.getAttribute('data-d'))); render();
      });
      $$('[data-cond]', qb).forEach(function (b) {
        b.addEventListener('click', function () {
          cond = b.getAttribute('data-cond');
          $$('[data-cond]', qb).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          render();
        });
      });
      $$('[data-extra]', qb).forEach(function (c) { c.addEventListener('change', function () { extras[c.getAttribute('data-extra')] = c.checked; render(); }); });
      render();
    }

    /* ---- Reveal what starts below the fold ---- */
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); e.target.classList.remove('pre'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px' });
      $$('.rv').forEach(function (el) {
        if (el.getBoundingClientRect().top > window.innerHeight) { el.classList.add('pre'); io.observe(el); }
      });
    }
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-mfb]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
